<div>
  <div class="row" *ngIf="!clientEnable">
    <div class="col pl-3">
      <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;" *ngIf="!clientedit">
        Case Manager
      </h4>
    </div>
  </div>

  <div *ngIf="global.globalAgencyId == null || global.globalAgencyId == undefined || global.globalAgencyId == '00000000-0000-0000-0000-000000000000' || global.globalAgencyId == 0|| this.global.globalAgencyId == '' ">
    <div class="row mt-4">
      <div class="col">
        <div class="card border-0 box-shadow">
          <div class="card-body widget-body pt-2">
            <div class="text-center text-danger">
              <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                details</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="global.globalAgencyId != null && global.globalAgencyId != '' && global.globalAgencyId != undefined && global.globalAgencyId != '00000000-0000-0000-0000-000000000000'" class="row mt-4">
    <div class="col">
      <div class="card border-0 box-shadow">
        <div class="card-body widget-body pt-2">
          <div class="row mt-2">
            <div class="ml-auto mr-4">
              <button type="button" class="btn btn-primary btn-sm text-right mb-1" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" data-bs-toggle="modal" data-bs-target="#exportascsvmodel">
                Export as CSV
              </button>
            </div>
          </div>

          <div class="row" *ngIf="!clientEnable">
            <div class="col-lg-4">
              <div class="col-lg-12">
                <label class="fw-bold">Filter By</label>
              </div>
              <div class="col-lg-12">
                <select [(ngModel)]="SearchColumn" class="form-select" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" (ngModelChange)="setDefaultValue()">
                  <option *ngFor="let item of filterItems | keyvalue" [ngValue]="item">{{item.value}}</option>
                </select>
              </div>
            </div>

            <div class="col-lg-4" *ngIf="SearchColumn.key != ''">
              <div class="col-lg-12">
                <label class="fw-bold">{{SearchColumn.value}}</label>
              </div>
              <div class="col-lg-12">
                <input (keydown)="onKeydown($event)" type="text" class="form-control ml-1" [(ngModel)]="SearchText" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'" />
              </div>
            </div>

            <div class="col-lg-4">
              <div class="col-lg-12 mt-2">
                <label></label>
              </div>
              <div class="col-lg-12">
                <button type="button" class="btn btn-primary btn-sm ml-2" [disabled]="global.globalAgencyId == 0" (click)="Search()">
                  Apply
                </button>
              </div>
            </div>
          </div>

          <div class="row mb-2 mt-2 pl-3 pr-3" *ngIf="!clientEnable">
            <div class="col-lg-8">
              <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#casemodalopen" *ngIf="fp.casemanagercreate" (click)="CaseCreateupdate('new')" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">Add Case Manager</button>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" *ngIf="!clientedit">
              <button type="button" class="btn btn-primary btn-sm" style="float:right" (click)="Refresh()" [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">
                <i class="fa fa-repeat"></i> Refresh
              </button>
            </div>
          </div>

          <div class="row pl-3 pr-3">
            <div class="col-lg-12">
              <ejs-grid #grid [dataSource]='casedata | async' [allowResizing]='true' *ngIf="global.globalAgencyId != 0" [allowSorting]='true'
               allowPaging='true' [allowFiltering]='true' (resizeStop)="onResize($event)" [pageSettings]='initialPage' [filterSettings]='filterOptions' (actionBegin)="onActionComplete($event)" [showColumnChooser]='true' (dataStateChange)='dataStateChange($event)'>
                <e-columns>
                  <e-column width=100 uid="action" headerText="Actions" textAlign="center" [showInColumnChooser]='false'>
                    <ng-template #template let-data *ngIf="!clientEnable">
                      <button *ngIf="fp.casemanagerupdate" class="btn btn-edit-table" data-bs-toggle="modal" data-bs-target="#casemodalopen" (click)="CaseCreateupdate('edit'); selectCasedetails(data)"><i class="fa fa-edit"></i></button>&nbsp;
                      <button *ngIf="fp.casemanagerdelete" class="btn btn-delete-table" data-bs-toggle="modal" data-bs-target="#deletemodal" (click)="selectCasedetails(data)"><i class="fa fa-trash"></i></button>
                    </ng-template>
                    <ng-template #template let-data *ngIf="clientEnable">
                      <input type="radio" (change)="caseemit(data)">
                    </ng-template>
                  </e-column>
                  <e-column width=100 field="name" headerText="Name" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column width=100 field="street" headerText="Street" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column width=100 field="state" headerText="State" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column width=100 field="city" headerText="City" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column width=100 field="zip" headerText="Zip" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column width=100 field="county" headerText="County" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column width=100 field="phone" headerText="Telephone" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column width=100 field="fax" headerText="Fax" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <!-- <e-column minWidth=100 field="alternate_Fax" headerText="Alternative Fax" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column> -->
                  <e-column width="150" field="agencyPhoneNum" headerText="Agency Phone Number" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column width=100 field="email" headerText="Email" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                      <div class="d-none d-lg-block">
                        <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true"></i></span>
                      </div>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>
          </div>

          <div *ngIf="(casedata | async)?.length === 0 && global.globalAgencyId != '00000000-0000-0000-0000-000000000000'" class="text-center" style="color:red">
            <p>No data available</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for Create and Update -->
<span id="opencasemanModal1" data-bs-toggle="modal" data-bs-target="#casemodalopen"></span>
<div class="modal fade modalbackgrod" id="casemodalopen" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span *ngIf="ModelType == 'new'">Create Case Manager</span>
          <span *ngIf="ModelType == 'edit'">Update Case Manager</span>
        </h5>
        <button type="button" class="btn-close" (click)="closecase()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="CaseForm">
          <div class="mb-3 row">
            <div class="col-lg-5">
              <label for="name" class="form-label">Name<sup class="super-script">*</sup></label>
            </div>
            <div class="col-lg-7">
              <input type="text" class="form-control" id="name" formControlName="name" [(ngModel)]="Case.name" name="name" (ngModelChange)="checkpopup('Name')" />
            </div>
          </div>
          <span class="help-block text-danger text-center" *ngIf="!CaseForm.get('name').valid && CaseForm.get('name').touched">
            <p>Please Enter Name</p>
          </span>
          <div class="mb-3 row" [formGroup]="CaseForm">
            <div class="col-lg-5">
                <label>Street</label>
            </div>
            <div class="col-lg-7 mt-1">
                <input type="text" class="form-control" formControlName="street" [(ngModel)]="Case.street"
                    name="street">
            </div>
        </div>

        <div class="mb-3 row" [formGroup]="CaseForm">
          <div class="col-lg-5">
              <label>City</label>
          </div>
          <div class="col-lg-7 mt-1">
              <input type="text" class="form-control" formControlName="city" [(ngModel)]="Case.city"
                  name="city">
          </div>
        </div>

        <div class="mb-3 row" [formGroup]="CaseForm">
            <div class="col-lg-5">
                <label>State</label>
            </div>
            <div class="col-lg-7 mt-1">
                <ng-select [(ngModel)]="Case.state" [items]="stateList" class="width25" [searchable]="true"
                    formControlName="state" [clearable]="true" bindLabel="name" bindValue="abbreviation">
                </ng-select>
            </div>
        </div>


        


        <div class="mb-3 row" [formGroup]="CaseForm">
            <div class="col-lg-5">

                <label>Zip</label>
            </div>
            <div class="col-lg-7 ">

                <input type="text" class="form-control" formControlName="zip" [(ngModel)]="Case.zip"
                    maxlength="8" minlength="5" name="zip" (keypress)="keyPress($event)">
                <div class="error"
                    *ngIf="CaseForm.controls['zip'].touched && CaseForm.controls['zip'].invalid">
                    Enter Valid five digit number</div>

            </div>
        </div>

          <div class="mb-3 row">
            <div class="col-lg-5">
              <label for="county" class="form-label">County</label>
            </div>
            <div class="col-lg-7">
              <input type="text" class="form-control" id="county" formControlName="County" [(ngModel)]="Case.county" name="county" (ngModelChange)="checkpopup('County')" />
            </div>
          </div>

          <div class="mb-3 row">
            <div class="col-lg-5">
              <label for="phone" class="form-label">Telephone</label>
            </div>
            <div class="col-lg-7">
              <input type="text" min="0" max="99999999999999" class="form-control" id="phone" formControlName="Telephone" [(ngModel)]="Case.phone" name="Telephone" (ngModelChange)="DemographicPhoneFormat()" (keypress)="numberOnly($event)" maxlength="14" />
            </div>
          </div>

          <div class="mb-3 row">
            <div class="col-lg-5">
              <label for="fax" class="form-label">Fax</label>
            </div>
            <div class="col-lg-7">
              <input type="text" min="0" max="99999999999999" class="form-control" id="fax" formControlName="Fax" [(ngModel)]="Case.fax" name="Fax" (ngModelChange)="DemographicPhoneFormat1()" (keypress)="numberOnly($event)" maxlength="14" />
            </div>
          </div>

          <div class="mb-3 row">
            <div class="col-lg-5">
              <label for="agencyPhone_num" class="form-label">Agency Phone Number</label>
            </div>
            <div class="col-lg-7">
              <input type="text" min="0" max="99999999999999" class="form-control" id="caseAgencyPhoneNumber" formControlName="AgencyPhoneNumber" [(ngModel)]="Case.agencyPhoneNum" name="agencyPhoneNum" (ngModelChange)="DemographicPhoneFormat2()" (keypress)="numberOnly($event)" maxlength="14" />
            </div>
          </div>

          <div class="mb-3 row">
            <div class="col-lg-5">
              <label for="email" class="form-label">Email</label>
            </div>
            <div class="col-lg-7">
              <input type="email" class="form-control" id="email" formControlName="Email" [(ngModel)]="Case.email" name="Email" (ngModelChange)="checkpopup('Email')" (keypress)="global.preventforSpace($event)" />
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12 col-md-12 d-inline-flex">
              <label class="mr-1 label-bold w-50"></label>
              <span *ngIf="checkEmailValidation" style="color:red">Please enter a valid email</span>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary btn-sm" (click)="SaveOrUpdateCase();" [disabled]="!CaseForm.valid || isSaveorUpdateBoolean">
          <span *ngIf="ModelType == 'new'">Save & Close</span>
          <span *ngIf="ModelType == 'edit'">Update & Close</span>
        </button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="openDialog()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal for Delete Confirmation -->
<span id="openModal2" data-bs-toggle="modal" data-bs-target="#deletemodal"></span>
<div class="modal fade" id="deletemodal" data-bs-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Delete Record</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="canceldelete()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>Do you want to delete this record?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger btn-sm" (click)="deleteCase()">Delete</button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="canceldelete()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal for Closing without Save -->
<span id="cancelcasemanmodal" data-bs-toggle="modal" data-bs-target="#ClosecasemanModal"></span>
<div class="modal fade" id="ClosecasemanModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        You want to close without saving?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-sm" (click)="closeAddUpdateModal()">Yes</button>
        <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal for Export CSV -->
<span id="exportascsv" data-bs-toggle="modal" data-bs-target="#exportascsvmodel"></span>
<div class="modal fade" id="exportascsvmodel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Export as CSV</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-6">
            <button class="btn btn-primary btn-sm mb-1" (click)="exportCaseWithPaginationCsv()">
              Print Current page
            </button>
          </div>
          <div class="col-lg-6">
            <button class="btn btn-primary btn-sm mb-1" (click)="exportCaseCsv()">
              Print All pages
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

